// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__Q2cMe","stepStyle":"style_stepStyle__W7lqI"};